export var initialZoneState = Object.freeze({
    overall: true,
    blue: false,
    green: false,
    gold: false,
});
